import { GeoJSON } from 'geojson'

import { TaskDefinition } from '../../types/task'

export interface TaskLocation {
  id: number | string | null
  name: string
  type: string
  address: string
  linkedAlertsCount?: number
  lastUpdated?: string
  enabledAlert?: boolean
  geoJson?: GeoJSON
  geometryType?: string | null | undefined
}

export interface TaskLocationPopoutProps {
  task?: TaskDefinition
  locationInput?: TaskLocation
  testId?: string
  onUpdated: (location: TaskLocation | null) => void
  mode: 'CREATE' | 'EDIT'
  placeholder?: string
  error?: string
}

export const defaultTaskDefinitionValues: TaskDefinition = {
  id: `task-assignment-${Date.now()}`,
  taskDefinition: {
    id: `task-id-${Date.now()}`,
    locations: [],
  },
  status: 'REQUESTED',
  assignedByOrg: {
    id: 0,
    name: '',
    avatar: null,
  },
  onwardAssignedToOrg: null,
  assignedVehicle: null,
}
